document.querySelectorAll<HTMLElement>("[data-bs-toggle=modal]").forEach(el =>
{
	let primaryLink = el.dataset.bsPrimaryLink;
	let modalPrimaryButton = document.querySelector("#loginModal .model-primary-button a");

	el.addEventListener("click", event =>
	{
		if (primaryLink && modalPrimaryButton)
		{
			modalPrimaryButton.setAttribute("href", primaryLink);
		}
	});
});
